import { post } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const saveScreenshots = async (payload) => {
  const builder = new UrlBuilder(`/save-screenshots`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const saveFile = async (payload) => {
  const builder = new UrlBuilder(`/applications/save-file`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
